import { destroyServerCookies } from 'utility-tools/module/cookies'
import { appConfigContext } from 'nexchange-service/appServiceConfig'

import { setHeadersFromStore } from './setHeadersFromStore'
import { requestIsUserRegistered, TUserTokenDto } from './api'
import { setUserInfoInStorage } from './userInfo'
import { getAuthToken, setAuthToken, setUserToken } from './auth'

const trySaveAnonymousAuthentication = anonymousAuthToken => {
    const authToken = getAuthToken()
    if (!authToken) {
        setAuthToken(anonymousAuthToken)
    }
}

const saveAuthentication = (userTokenDto: TUserTokenDto, keepSignedIn = true) => {
    const authCookiesOptions = keepSignedIn
        ? { maxAge: appConfigContext.getAppConfig().AUTH_EXPIRATION_PERIOD }
        : {}

    // TODO, refactor to use LS
    // setCookie(null, 'authToken', userTokenDto?.access_token, authCookiesOptions)
    // setCookie(null, 'userToken', JSON.stringify(userTokenDto), authCookiesOptions)

    setAuthToken(userTokenDto?.access_token)
    setUserToken(userTokenDto)

    setHeadersFromStore()
}

// todo not used?
const removeAuthenticationServerSide = (req, res) => {
    destroyServerCookies(req, res, ['userToken', 'authToken'])
}

const removeAuthenticationClientSide = () => {
    // TODO, refactor to use LS
    // Cookies.remove('authToken', { path: '/order' })
    // Cookies.remove('userToken', { path: '/order' })
    // Cookies.remove('authToken', { path: '/user' })
    // Cookies.remove('userToken', { path: '/user' })
    // Cookies.remove('authToken')
    // Cookies.remove('userToken')

    localStorage.removeItem('authToken')
    localStorage.removeItem('userToken')

    setHeadersFromStore()
    setUserInfoInStorage(null)
}

const removeAuthOnAnonymousUserFound = async () => {
    const authToken = getAuthToken()
    if (!authToken) return

    if (!(await requestIsUserRegistered())) {
        await removeAuthenticationClientSide()
    }
}

export {
    trySaveAnonymousAuthentication,
    saveAuthentication,
    removeAuthenticationClientSide,
    removeAuthenticationServerSide,
    removeAuthOnAnonymousUserFound,
}